import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Parser } from "html-to-react";

const Pages = () => {
  const { id } = useParams();

  const [pages, setPages] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_URL}/api-pages/${id}`);
        const data = await res.json();
        setPages(data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, [id]);

  const htmlParser = new Parser();

  return (
    <div>
      {pages.map((data) => (
        <p key={data.id} className="container mx-auto">
          {htmlParser.parse(data.descriptions)}
        </p>
      ))}
    </div>
  );
};

export default Pages;
